'use strict';

const menu = {
	toggleMainNav: function() {

		const menuItems = document.querySelectorAll(".menuItem .menuItem__title, .subMenu__listing__item .subMenu__listing__item__title");

		const nav = document.querySelector('.mainHeader__nav');

		if( menuItems ){
			menuItems.forEach((menuItem) => {
	
				const currentItem = menuItem.parentNode;
		
				menuItem.addEventListener("click", () => {
	
					let addClass = currentItem.classList.contains('active') ? false : true;
					let isN1 = currentItem.classList.contains('menuItem') ? true : false;
		
					menuItems.forEach((menuItem) => {
						if (isN1 && menuItem.parentNode.classList.contains('menuItem') || menuItem.parentNode.classList.contains('subMenu__listing__item') ) {
							menuItem.parentNode.classList.remove('active');
						}
					});
		
					if (isN1 && addClass || !isN1 && addClass) {
						currentItem.classList.add("active");
		
						if(window.innerWidth > 991){
							const firstChild = currentItem.querySelector('.subMenu__listing__item:first-child');
							if( firstChild ){
								firstChild.classList.add("active");
							}
						}
					}
		
					//Manage open state on mobile
					if( nav ){
						if (isN1 && addClass) {
			
							nav.classList.add('subOpen')
			
						}else if(isN1 && !addClass){
			
							nav.classList.remove('subOpen')
			
						}else if(!isN1 && addClass){
			
							nav.classList.add('linkOpen')
			
						}else if(!isN1 && !addClass){
			
							nav.classList.remove('linkOpen')
			
						}
					}
		
				});
			});
		}
	
	},
	toggleMainNavMobile: function() {

		const toggleNav = document.getElementById("toggleNav");

		const mainNav = document.getElementById("mainNav");

		if(toggleNav && mainNav){
			toggleNav.addEventListener("click", () => {
		
				toggleNav.classList.toggle('open');
		
				mainNav.classList.toggle('open');
		
			});
		}
	
	
	},
	hideShowMenuOnScroll: function() {
	
		// Initial state
		let scrollPos = 0;

		const mainHeader = document.getElementById('mainHeader');

		if( mainHeader ){
			window.addEventListener('scroll', function() {
		
				// detects new state and compares it with the new one
				if ((document.body.getBoundingClientRect()).top < scrollPos && scrollPos < -150) {
					mainHeader.classList.add('hide');
				} else {
					mainHeader.classList.remove('hide');
				}
		
				// saves the new position for iteration.
				scrollPos = (document.body.getBoundingClientRect()).top;
		
			});
		}
	
	
	},
	init: function() {
		this.toggleMainNav();
		this.toggleMainNavMobile();
		// this.hideShowMenuOnScroll();
	}
}

window.addEventListener('DOMContentLoaded', function() {
	menu.init();
});